module.exports = __webpack_public_path__ + "static/media/Plateau_L_1.0f6641d8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/Plateau_L_1.svg
// module id = 786
// module chunks = 0